import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { APPLICATION_ICON_TRIGGERS, BRAND_ICONS, TITLES_TO_IGNORE } from "./constants";
dayjs.extend(relativeTime);
export var getTimes = function getTimes(timestamp) {
  if (!timestamp) {
    return {
      date: null,
      time: null,
      humanTime: null,
      invalidTime: null
    };
  }
  var dateTime = dayjs(timestamp);
  var date = dateTime.format("DD/MM/YYYY");
  var time = dateTime.format("h:mm:ss A");
  var humanTime = dateTime.isValid() ? dateTime.fromNow() : null;
  return {
    date: date,
    time: time,
    humanTime: humanTime,
    invalidTime: !dateTime.isValid()
  };
};
export var getBrand = function getBrand(name) {
  if (!name) return undefined;
  var normalised = name.toLowerCase();
  var brand = APPLICATION_ICON_TRIGGERS.find(function (trigger) {
    return normalised.includes(trigger);
  });
  return BRAND_ICONS[brand];
};
var removeNonLettersFromInitials = function removeNonLettersFromInitials(initials) {
  return initials.replace(/[^a-zA-Z]+/g, "");
};
export var getInitials = function getInitials(name, forcedInitials) {
  if (forcedInitials) {
    return forcedInitials;
  }
  if (!name) {
    return null;
  }
  var initials = name.split(" ").filter(function (word) {
    return word && !TITLES_TO_IGNORE.includes(word.toLowerCase());
  }).map(function (word) {
    return word && word[0].toUpperCase();
  }).join("");
  if (initials.length > 2) {
    return null;
  }
  return removeNonLettersFromInitials(initials);
};